import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../App/ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../App/Util/axiosErrorHandler'
import { TErrorDescriptor } from '../../../ErrorHandling/store'
import { IBlockFormSubmit } from '../../types'
import { IAPICreateBlock } from '../../types/api'
import { createBlockTransformer } from '../transformer/createBlockTransformer'

type TCreateBlockReturn = TErrorDescriptor & {
  uuid: string
}

export const createBlock = createAsyncThunk<
  TCreateBlockReturn,
  IBlockFormSubmit,
  IThunkReject<any>
>('block/create', async (blockData, { rejectWithValue }) => {
  let apiData: null | TCreateBlockReturn = null

  try {
    const apiBlockData: IAPICreateBlock = createBlockTransformer(blockData)

    const promise = clientSDK.instance().post<{
      uuid: string
    }>('calendar/blockeds', apiBlockData)

    const result = await promise

    apiData = {
      title: 'Block has been created.',
      icon: 'check',
      uuid: result.data.uuid,
      type: 'info',
    }
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return apiData
})
